
jQuery( function( $ ) {
	$( 'body.single-product .summary-inner-wrapper .qala-star-rating, .summary-rating__count' ).on( 'click', function() {
		const productBlockReviews = $( '.product-block-reviews' );

		if ( 0 >= productBlockReviews.length ) {
			return;
		}

		productBlockReviews.removeClass( 'accordion-hidden' );

		$( 'html, body' ).animate( {
			scrollTop: productBlockReviews.offset().top - $( '.site-header' ).height(),
		}, 400 );
	} );
} );
